import React from 'react'

const DataNotFound = () => {
  return (
    <div className="tab-chart-blk">
    <p>No data available</p>
  </div>
  )
}

export default DataNotFound